import { subscriptionSettingsSchema } from "@/schemas/subscription";
import { firstIssueMessage } from "@/lib/validation-errors";
import type { SubscriptionSettingsView } from "@/types";

type NumberKey =
  | "priceSemiannual"
  | "priceAnnual"
  | "vatRate"
  | "paymentLinkTtlHours"
  | "renewalReminderDays"
  | "maxRemindersPerRun";

const NUMBER_FIELDS: Array<[NumberKey, string]> = [
  ["priceSemiannual", "Polugodišnja cijena"],
  ["priceAnnual", "Godišnja cijena"],
  ["vatRate", "PDV stopa"],
  ["paymentLinkTtlHours", "Trajanje payment linka"],
  ["renewalReminderDays", "Podsjetnik prije isteka"],
  ["maxRemindersPerRun", "Max podsjetnika po pokretanju"],
];

export type SubscriptionConfigPatch = Pick<SubscriptionSettingsView, NumberKey | "vatIncluded" | "issuer">;

/**
 * Checks the admin subscription config before PUT. An emptied number input is
 * NaN in the draft; without this it went out as null and came back as an
 * unlabeled "Polje je obavezno". Range rules come from the same schema the
 * server uses, so the messages match.
 */
export function subscriptionConfigError(patch: SubscriptionConfigPatch): string | null {
  for (const [key, label] of NUMBER_FIELDS) {
    if (!Number.isFinite(patch[key])) return `${label}: polje je obavezno.`;
  }
  const parsed = subscriptionSettingsSchema.safeParse(patch);
  if (parsed.success) return null;
  return firstIssueMessage(parsed.error.issues, "Postavke pretplate nisu ispravne.", patch);
}
